import { AsyncActionHandler } from 'action-handler';
import { triggerAppSync, triggerWifiConnect } from 'actions/gallery';
import { markAppInstalled, setPendingAppInstallStatus } from 'actions/registry';
import { triggerContinueInstall } from 'actions/install-flow';
import App from 'models/app';

export default new AsyncActionHandler({
  name: 'install_app',
  stateProp: 'installApp',
  handler: (appId) => async (dispatch, getState) => {
    const state = getState();
    const app = App.selectFromState(appId, state);
    const requiresWifi = !!(app && app.requiresWifi);

    dispatch(setPendingAppInstallStatus(app));

    await dispatch(
      triggerContinueInstall({
        show: false,
        hasBeenSeen: true,
        shouldContinue: true
      })
    );

    if (requiresWifi) {
      try {
        await dispatch(triggerWifiConnect());
      } catch (error) {
        return;
      }
    }

    // Mark app installed in AIS
    await dispatch(markAppInstalled(appId));

    // Tell mobile to start app sync
    await dispatch(triggerAppSync({ requiresWifi, force: true }));
  }
});
